import {
  forwardRef,
  ChangeEventHandler,
  InputHTMLAttributes,
  TextareaHTMLAttributes,
} from 'react';
import Typography from '../Typography';
import Card from '../Card';
import styles from './Input.module.scss';
import classNames from 'classnames';

export interface InputProps {
  inputProps?:
    | InputHTMLAttributes<HTMLInputElement>
    | TextareaHTMLAttributes<HTMLTextAreaElement>;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  className?: string;
  disabled?: boolean;
  label?: string;
  name: string;
  value?: any;
}

function Input(
  { inputProps = {}, className, label, ...props }: InputProps,
  ref: any,
) {
  const isTextArea = (inputProps as any).type === 'textarea';
  return (
    <div className={classNames(styles.container, className)}>
      {label && (
        <Typography
          className={styles.label}
          htmlFor={props.name}
          textType="p1"
          as="label"
        >
          {label}
        </Typography>
      )}
      <Card
        {...inputProps}
        {...props}
        padding={isTextArea ? '1rem 1.25rem' : '0.75rem 1.25rem'}
        as={isTextArea ? 'textarea' : 'input'}
        backgroundColor="background-3"
        className={classNames(inputProps.className, styles.field)}
        ref={ref}
      />
    </div>
  );
}

export default forwardRef(Input);
